// PA-5: one booking pop-up can cover several sessions of one instructor, and a session may carry
// its own payment instructions instead of the instructor's profile default. So the student gets
// one payment block per distinct destination, each with the amount that goes there.
//
// A destination is the instructions text and the QR together: same text with a different QR is a
// different account, and merging them would send money to the wrong one.

// Blank strings count as missing, matching the server's `resolveSessionPayment`.
const orNull = (v) => v || null;

function amountOf({ session, booking }) {
  // The booking's own price first (what this seat costs), then the session price the server
  // echoed, then the price the student saw when picking the session.
  const price = booking?.price ?? booking?.session?.price ?? session?.price;
  return Number.isFinite(price) ? price : 0;
}

// booked: [{ session, booking }] — the successful rows of the pop-up's results.
// Returns [{ paymentInstructions, paymentQrUrl, total, sessions }] in first-seen order.
export function groupPaymentBlocks(booked) {
  const blocks = new Map();
  for (const row of booked || []) {
    const paymentInstructions = orNull(row.booking?.session?.paymentInstructions);
    const paymentQrUrl = orNull(row.booking?.session?.paymentQrUrl);
    const key = JSON.stringify([paymentInstructions, paymentQrUrl]);
    let block = blocks.get(key);
    if (!block) {
      block = { paymentInstructions, paymentQrUrl, total: 0, sessions: [] };
      blocks.set(key, block);
    }
    block.total += amountOf(row);
    block.sessions.push(row.session);
  }
  return [...blocks.values()];
}
